import React from 'react';
import {injectIntl} from 'react-intl';
import IgBusinessStore from './stores/IgBusinessStore';
import Card from './Card.jsx';

import {observer} from 'mobx-react';
function CardsList({intl,cards, onSelect}){
  return(
    <div className="cards-list">
      {cards.map( (card, idx) =>
        <Card key={idx} card={card} 
          onClick={() => {
            if( onSelect ){
              onSelect(card)
            } 
          }
        } 
        />
      )}
    </div>
  );
}

export default injectIntl(observer(CardsList));